<template>
  <div class="toc">
    <div class="toc__inner" ref="tocInner" @click="handleClick"></div>
  </div>
</template>

<script>
import editorSvc from '../services/editorSvc';
import store from '../store';

export default {
  methods: {
    handleClick(e) {
      // Find the clicked TOC item
      const tocItem = e.target.closest('.toc-item');
      if (!tocItem) return;
      
      // Check if editorSvc has preview context
      if (!editorSvc.previewCtx || !editorSvc.previewCtx.sectionDescList) {
        return;
      }
      
      // Find the index from data attribute
      const sectionIdx = Number.parseInt(tocItem.dataset.index, 10);
      if (Number.isNaN(sectionIdx)) return;
      
      // Get the section description
      const sectionDesc = editorSvc.previewCtx.sectionDescList[sectionIdx];
      if (!sectionDesc) return;
      
      // Function to perform the scroll
      const doScroll = () => {
        // Scroll editor (if visible) - use the editor element directly
        if (sectionDesc.editorElt && editorSvc.editorElt) {
          sectionDesc.editorElt.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
        // Scroll preview (if visible)
        if (sectionDesc.previewElt) {
          sectionDesc.previewElt.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      };
      
      // On mobile, close sidebar first then scroll
      if (window.innerWidth <= 900) {
        store.dispatch('data/toggleSideBar', false);
        setTimeout(doScroll, 300);
      } else {
        doScroll();
      }
    },
  },
};
</script>

<style lang="scss">
@import '../styles/variables.scss';

$toc-font-size: 14px;

.toc {
  height: 100%;
  overflow: auto;
}

.toc__inner {
  padding: 5px 10px 40px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

// Simple flat TOC item - matches explorer style
.toc-item {
  position: relative;
  cursor: pointer;
  font-size: $toc-font-size;
  padding: 4px 10px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: rgba(0, 0, 0, 0.87);

  .app--dark & {
    color: rgba(255, 255, 255, 0.87);
  }

  .app--sepia & {
    color: #5b4636;
  }

  .app--nord & {
    color: #d8dee9;
  }

  .app--solarized-light & {
    color: #586e75;
  }

  .app--solarized-dark & {
    color: #93a1a1;
  }

  .app--dracula & {
    color: #f8f8f2;
  }

  .app--monokai & {
    color: #f8f8f2;
  }

  &:hover {
    background-color: rgba(0, 0, 0, 0.1);

    .app--dark &,
    .app--nord &,
    .app--solarized-dark &,
    .app--dracula &,
    .app--monokai & {
      background-color: rgba(255, 255, 255, 0.1);
    }

    .app--sepia & {
      background-color: rgba(91, 70, 54, 0.1);
    }

    .app--solarized-light & {
      background-color: rgba(101, 123, 131, 0.1);
    }
  }

  &:active {
    background-color: rgba(0, 0, 0, 0.15);

    .app--dark &,
    .app--nord &,
    .app--solarized-dark &,
    .app--dracula &,
    .app--monokai & {
      background-color: rgba(255, 255, 255, 0.15);
    }

    .app--sepia & {
      background-color: rgba(91, 70, 54, 0.15);
    }

    .app--solarized-light & {
      background-color: rgba(101, 123, 131, 0.15);
    }
  }
}

// Level indentation
.toc-item--level-1 {
  font-weight: 600;
}

.toc-item--level-2 {
  padding-left: 20px;
}

.toc-item--level-3 {
  padding-left: 30px;
}

.toc-item--level-4 {
  padding-left: 40px;
}

.toc-item--level-5 {
  padding-left: 50px;
}

.toc-item--level-6 {
  padding-left: 60px;
}

// Container for TOC items (generated by editorSvc)
.cl-toc-section {
  display: block;
}
</style>
